export interface Dataset {
  name: string;
  url: string;
  elapsed: string;
}

export const Datasets: Dataset[] = [
  {
    name: "T100 Singapore 2025 Men",
    url: "https://example.com/men",
    elapsed: "1h 32m 52s",
  },
  {
    name: "T100 Singapore 2025 Women",
    url: "https://example.com/women",
    elapsed: "3h 45m 05s",
  },
];
